export default "__VITE_ASSET__DDEsp0Ta__"